import { Notes } from './notes.model';

export class ProjectInformationHistory {
    id: string;
    projectCode: string;
    fileName: string;
    fileURL: string;
    bdContact: string;
    geography: string;
    clientLogo: string;
    projectManager: string;
    projectName: string;
    restrictedContent: boolean;
    geographyURL: string;
    tags: Array<string>;
    client: string;
    region: string;
    vertical: string;
    projectStatus: string;
    projectType: string;
    projectSize: string;
    deliveryModel: string;
    createdBy: string;
    createdOn: any;
    updatedOn: any;
    updatedBy: string;
    status: string;
    caseStudyLogo:string;
    organizationId: string;
    organizationName: string;
    approvedBy: string;
    notes: Array<Notes>;
    FileDownloadCount: Number;
    FileViewCount: Number;
    version: number;
    projectId: string;
    isLocked: boolean;
    contentType: string;
    bussinessCaseFileName: string;
    bussinessCaseFileURL: string;
    deliveryOrganization: string;
    sharepointId:string;

}